// Import GA4 E-commerce helper
import * as GA4 from './ga4-ecommerce.js';

(function ($) {
    "use strict";

    async function loadCartSummary() {
        const cartSummaryDiv = $('#order-summary');
        if (cartSummaryDiv.length) {
            try {
                const response = await fetch('/index.php?aio=kosik-prehled', {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                $(cartSummaryDiv).hide().html(data.content).slideDown();

                // GA4 E-commerce: Begin Checkout event
                // Extract cart items and total value from the page
                const cartItems = extractCartItemsFromPage();
                const totalValue = extractTotalValueFromPage();

                if (cartItems.length > 0) {
                    GA4.beginCheckout(cartItems, totalValue, 'CZK');
                }
            } catch (error) {
                console.error('Error fetching cart summary:', error);
            }
        }
    }

    function extractCartItemsFromPage() {
        const items = [];
        // This would need to be called after cart data is loaded
        // For now, we'll return empty array and implement this based on actual page structure
        // You would need to parse the loaded cart summary HTML or get data from API
        return items;
    }

    function extractTotalValueFromPage() {
        // Extract total value from the page
        // This would need to parse the cart summary after it's loaded
        return 0;
    }

    function validateOrderData() {
        const email = $('#email_contact').val();
        const mobile = $('#mobile_contact').val();
        const zip = $('#zip-code').val();
        const checkbox = $('#accept-condition');
        const errorMessage = $('#chybova-hlaska');

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobilePattern = /^\+?\d+$/;
        const zipPattern = /^\d{3}\s?\d{2}$/;

        if (!emailPattern.test(email)) {
            alert('Please enter a valid email address.');
            return false;
        }

        if (!mobilePattern.test(mobile)) {
            alert('Please enter a valid mobile number.');
            return false;
        }

        if (!zipPattern.test(zip)) {
            alert('Please enter a valid ZIP code.');
            return false;
        }

        if (!checkbox.is(':checked')) {
            errorMessage.show();
            return false;
        } else {
            errorMessage.hide();
        }

        return true;
    }

    $(document).ready(() => {
        loadCartSummary();

        const form = $('#objednavka-form');

        form.on('submit', (event) => {
            if (!validateOrderData()) {
                event.preventDefault();
            }
        });
    });
    window.validateOrderData = validateOrderData;
})(jQuery);